export const ANNUAL_INCOME_MIN = 500000;
export const ANNUAL_INCOME_MAX = 39000000;

export const ANNUAL_INCOME_FIELD_NAME = "annualIncome";

const normalizeFieldToken = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");

const ANNUAL_INCOME_TOKENS = ["annualincome", "annincome"];


export const findAnnualIncomeFieldName = (fields = []) => {
  const match = (fields || []).find((field) => {
    const token = normalizeFieldToken(
      field?.fieldReference || field?.name || field?.fieldName,
    );
    return ANNUAL_INCOME_TOKENS.some((known) => token.includes(known));
  });
  if (!match) return null;
  return match.fieldReference || match.name || match.fieldName || null;
};


export const getAnnualIncomeError = (value) => {
  if (value == null) return null;

  const income = Number(String(value).replace(/,/g, ""));
  if (!Number.isFinite(income)) return null;

  if (income < ANNUAL_INCOME_MIN) {
    return `Annual income must be at least ${ANNUAL_INCOME_MIN}.`;
  }
  if (income > ANNUAL_INCOME_MAX) {
    return `Annual Income must not exceed ${ANNUAL_INCOME_MAX}.`;
  }
  return null;
};